import { _t } from '@/i18n/t';

interface PendingInvoiceDialogProps {
  onClose: () => void;
  onPayNow: () => void;
}

const PendingInvoiceDialog = ({ onClose, onPayNow }: PendingInvoiceDialogProps) => (
  <div
    className="fixed inset-0 z-[1001] flex items-center justify-center bg-black/50"
    onClick={onClose}
  >
    <div
      className="bg-white rounded-xl w-[440px] max-w-[95vw] shadow-2xl p-6"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-lg font-semibold text-foreground m-0 mb-2">
        {_t('settings.subscription.invoiceModal.title')}
      </h3>
      <p className="text-sm text-muted-foreground m-0 mb-5">
        {_t('settings.subscription.invoiceModal.description')}
      </p>
      <div className="flex justify-end gap-3">
        <button
          data-th-button="true"
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-border bg-transparent px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
          onClick={onClose}
        >
          {_t('settings.subscription.invoiceModal.later')}
        </button>
        <button
          data-th-button="true"
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          onClick={onPayNow}
        >
          {_t('settings.subscription.invoiceModal.payNow')}
        </button>
      </div>
    </div>
  </div>
);

export default PendingInvoiceDialog;